import React from 'react';

// Components
import Modal from '../../components/Modal';

const TermsAndConditionsModal = ({onClose}) => {
    const body = <div className='overflow-auto h-72'>
        <div className="pl-2 space-y-4 text-sm">
            <p className="ml-6">
                Bileti almazdan öncə diqqətlə oxuyun və razılaşdığınızı təsdiq edin.
            </p>

            <div>
                <b className="text-md block">1. Ümumi müddəalar</b>
                <ul className="list-disc ml-8 space-y-1">
                <li>Bu qaydalar Tixy.az portalı tərəfindən təyin edilir.</li>
                <li>Bilet əldə etməklə siz bu qaydalara tam razı olduğunuzu təsdiq etmiş olursunuz.</li>
                </ul>
            </div>

            <div>
                <b className="text-md block">2. Biletin istifadə qaydası</b>
                <ul className="list-disc ml-8 space-y-1">
                <li>Hər bilet yalnız bir nəfər üçün keçərlidir.</li>
                <li>Biletlər şəxsi istifadə üçün nəzərdə tutulub və kommersiya məqsədilə təkrar satışı qadağandır.</li>
                <li>Tədbirə daxil olmaq üçün biletin fiziki və ya elektron versiyası təqdim edilməlidir.</li>
                </ul>
            </div>

            <div>
                <b className="text-md block">3. Biletin geri qaytarılması və dəyişdirilməsi</b>
                <ul className="list-disc ml-8 space-y-1">
                <li>Satılan biletlər aşağıdakı qaydalara uyğun olaraq geri qaytarıla bilər:</li>
                <li>Tədbirə 7 gündən çox müddət qalmış bilet geri qaytarıldıqda, bilet qiymətinin 50%-i tutulur, qalan məbləğ qaytarılır.</li>
                <li>Tədbirə 7 gündən az müddət qaldıqda, biletin geri qaytarılması və ya dəyişdirilməsi mümkün deyil.</li>
                <li>Tədbirin təşkili ilə bağlı dəyişikliklər (vaxt, məkan və s.) olduğu halda, təşkilatçı alternativ tədbirlər və ya qaytarma şərtləri barədə məlumat verəcək.</li>
                </ul>
            </div>

            <div>
                <b className="text-md block">4. Təhlükəsizlik və davranış qaydaları</b>
                <ul className="list-disc ml-8 space-y-1">
                <li>Tədbirdə iştirak edən hər kəs təşkilatçının və təhlükəsizlik xidmətinin təlimatlarına əməl etməlidir.</li>
                <li>Qanunsuz və ya qaydalara zidd davranış (alkoqol, siqaret, təhlükəli əşyalar, aqressiya və s.) aşkarlandıqda iştirakçı tədbirdən uzaqlaşdırıla bilər.</li>
                <li>10 yaşdan kiçik iştirakçılar yalnız valideyn və ya qanuni nümayəndə ilə tədbirdə iştirak edə bilər.</li>
                </ul>
            </div>

            <div>
                <b className="text-md block">5. Foto və video çəkiliş</b>
                <p className="ml-6">
                Təşkilatçı tədbir zamanı foto və video çəkiliş həyata keçirə bilər. İştirakçı bu materialların kommersiya və reklam məqsədilə istifadə edilməsinə etiraz etmədiyini təsdiq edir.
                </p>
            </div>

            <div>
                <b className="text-md block">6. Force Majeure (fors-major hallar)</b>
                <p className="ml-6">
                Təbiət fəlakətləri, dövlət qərarları, epidemiya və digər nəzarətimizdən kənar səbəblərdən tədbir təxirə salındıqda və ya ləğv olunduqda, təşkilatçı məsuliyyət daşımır. Bu hallarda mümkün həll yolları barədə məlumat veriləcək.
                </p>
            </div>

            <div>
                <b className="text-md block">7. Məlumatların qorunması</b>
                <p className="ml-6">
                Bilet alışı zamanı təqdim etdiyiniz şəxsi məlumatlar yalnız tədbirə aid məqsədlərlə istifadə olunur və üçüncü tərəflərə ötürülmür.
                </p>
            </div>

            <div className="pt-4">
                <p className="ml-6 font-semibold">
                ⸻ <br />
                Bileti alaraq yuxarıda qeyd olunan qaydalar və şərtlərlə tam razı olduğumu təsdiq edirəm.
                </p>
            </div>
        </div>
    </div>

    return <Modal 
        title="BİLET SATIŞ QAYDALARI VƏ ŞƏRTLƏRİ"
        body={body}
        buttons={
            <>
                <button type="button" onClick={() => onClose(true)} className="inline-flex w-full justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-900 sm:ml-3 sm:w-auto">Oxudum, qəbul edirəm</button>
                <button onClick={() => onClose(false)} type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Bağla</button>
            </>
        }
    />
}

export default TermsAndConditionsModal;